export var MediaConstants = {
  UploadBizId: 123,
  MediaBizId: '1005',
  MMSImageBiz: 4255
};
export var UploadMediaResStatus;
(function (UploadMediaResStatus) {
  UploadMediaResStatus[UploadMediaResStatus["Success"] = 0] = "Success";
  UploadMediaResStatus[UploadMediaResStatus["Failed"] = 1] = "Failed";
  UploadMediaResStatus[UploadMediaResStatus["Cancel"] = 2] = "Cancel";
})(UploadMediaResStatus || (UploadMediaResStatus = {}));
export var MediaSourceType = {
  AlbumAndCamera: 0,
  Camera: 1,
  Album: 2
};
export var MediaSelectType = {
  ImageAndVideo: 0,
  Image: 1,
  Video: 2
};
export var UploadMediaStatus;
(function (UploadMediaStatus) {
  UploadMediaStatus[UploadMediaStatus["Compressing"] = 1] = "Compressing";
  UploadMediaStatus[UploadMediaStatus["CompressSucceed"] = 2] = "CompressSucceed";
  UploadMediaStatus[UploadMediaStatus["CompressFailed"] = 3] = "CompressFailed";
  UploadMediaStatus[UploadMediaStatus["Uploading"] = 4] = "Uploading";
  UploadMediaStatus[UploadMediaStatus["UploadSucceed"] = 5] = "UploadSucceed";
  UploadMediaStatus[UploadMediaStatus["UploadFailed"] = 6] = "UploadFailed";
  UploadMediaStatus[UploadMediaStatus["UploadCanceled"] = 7] = "UploadCanceled";
})(UploadMediaStatus || (UploadMediaStatus = {}));

// 压缩错误 or 上传错误
export var UPLOAD_VIDEO_ERROR_STATUS = [UploadMediaStatus.UploadCanceled, UploadMediaStatus.CompressFailed, UploadMediaStatus.UploadFailed];
export var VIDEO_TYPE = ['.m4v', '.mov', '.avi', '.wmv', 'mp4'];
export var IMAGE_TYPE = ['.jpg', '.jpeg', '.png', '.gif'];